import { createPortal } from 'react-dom';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

/** Debe coincidir con NAVBAR_HEIGHT_PX en `constants/layoutHeaderInset` (navbar fijo z-index 1000) */
const NAVBAR_OFFSET_PX = 68 + 16;

/** Por encima del navbar, barras fijas y dropdowns de la búsqueda */
const MODAL_Z = 10050;

export default function SharedModal({ open, setOpen, title, content, panelClassName = '' }) {
  const handleClose = () => {
    if (typeof setOpen === 'function') {
      setOpen(false);
    }
  };

  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <Dialog open={!!open} onClose={handleClose} style={{ position: 'relative', zIndex: MODAL_Z }}>
      <DialogBackdrop className="fixed inset-0 bg-slate-900/40" style={{ zIndex: MODAL_Z }} />
      <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: MODAL_Z }}>
        <div
          className="flex min-h-full items-end justify-center p-4 pb-6 text-center sm:items-center sm:px-4 sm:pb-8"
          style={{ paddingTop: `max(1rem, ${NAVBAR_OFFSET_PX}px)` }}
        >
          <DialogPanel className={clsx('modal-tailwind relative z-[1]', panelClassName)}>
            <div className="bg-white px-4 pt-4 pb-4 sm:p-6 sm:pb-4">
              <div className="flex items-start gap-3">
                <DialogTitle
                  as="div"
                  className="min-w-0 flex-1 pr-1 text-left text-lg font-semibold leading-snug text-blue"
                >
                  {title}
                </DialogTitle>
                <button
                  type="button"
                  onClick={handleClose}
                  aria-label="Close dialog"
                  className="-m-1 shrink-0 rounded-md p-1 text-slate-600 transition hover:bg-slate-100 hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white"
                >
                  <XMarkIcon className="h-5 w-5" aria-hidden />
                </button>
              </div>
              <div>{content}</div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>,
    document.body,
  );
}
